<div class="h-100 d-flex flex-column justify-content-center align-items-center">
    <i-bs name="emoji-frown" class="text-primary mb-3" width="5rem" height="5rem"></i-bs>
    <h4 class="mb-3">{{invalidProperties?.titleText}}</h4>
    <p class="mb-3">{{invalidProperties?.errorText}}</p>
    <button type="button" class="btn btn-primary" (click)="goToStore()">Go to store</button>
</div>